/* tslint:disable */
/* eslint-disable */
/**
 * Eatgrim Shipping API
 * Eatgrim Shipping API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@soundsgood.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
* @export
* @enum {string}
*/
export var DeliveryTypeTypeEnum;
(function (DeliveryTypeTypeEnum) {
    DeliveryTypeTypeEnum["Doorstep"] = "doorstep";
    DeliveryTypeTypeEnum["Pickup"] = "pickup";
})(DeliveryTypeTypeEnum || (DeliveryTypeTypeEnum = {}));
export function DeliveryTypeFromJSON(json) {
    return DeliveryTypeFromJSONTyped(json, false);
}
export function DeliveryTypeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !exists(json, 'type') ? undefined : json['type'],
        'available': !exists(json, 'available') ? undefined : json['available'],
        'minPrice': !exists(json, 'minPrice') ? undefined : json['minPrice'],
        'maxPrice': !exists(json, 'maxPrice') ? undefined : json['maxPrice'],
    };
}
export function DeliveryTypeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'available': value.available,
        'minPrice': value.minPrice,
        'maxPrice': value.maxPrice,
    };
}
